import { CSSProperties } from "react";

import * as Color from "../../Color";
import { ButtonAppearance, ButtonStateAppearance } from "../ButtonAppearances";

type CSSCustomProperties = CSSProperties & Record<`--btn-${string}`, string>;

/**
 * Converts a ButtonStateAppearance to CSS custom property entries for a given state prefix.
 */
function stateToVars(prefix: string, state: ButtonStateAppearance): Record<string, string> {
  return {
    [`--btn-${prefix}color`]: Color.toString(state.foregroundColor),
    [`--btn-${prefix}bg`]: Color.toString(state.backgroundColor),
    [`--btn-${prefix}border-color`]: Color.toString(state.borderColor ?? state.backgroundColor),
    [`--btn-${prefix}text-decoration`]: state.textUnderline ? "underline" : "none",
  };
}

/**
 * Builds a CSSProperties object of CSS custom properties from a ButtonAppearance.
 * The token CSS module's `.custom` rules consume these variables for each state.
 */
export function getCustomAppearanceStyle(appearance: ButtonAppearance, iconOnly: boolean): CSSCustomProperties {
  const { vertical } = appearance.padding;
  let { horizontal } = appearance.padding;
  if (iconOnly) horizontal = vertical;

  return {
    "--btn-text-transform": appearance.label.uppercase ? "uppercase" : "capitalize",
    "--btn-letter-spacing": `${appearance.label.letterSpacing}px`,
    "--btn-padding": `${vertical / 16}rem ${horizontal / 16}rem`,
    "--btn-font-size": `${appearance.label.fontSize / 16}rem`,
    "--btn-line-height": `${appearance.label.lineHeight / 16}rem`,
    ...stateToVars("", appearance.normal),
    ...stateToVars("hover-", appearance.hover),
    ...stateToVars("active-", appearance.pressed),
    ...stateToVars("disabled-", appearance.disabled),
  };
}
